import { memo } from 'react'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { CommandGroup } from '@/components/ui/command'
import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import { cn } from '@/lib/utils'
import { SortableItem, type ColumnItem } from './sortable-item'

interface SortableGroupProps {
  columns: ColumnItem[]
  title: string
  toggleAllButtonText: string
  isVisible: boolean
  className?: string
  toggleAllColumns: () => void
  toggleColumnVisibility: (columnId: string) => void
}

const SortableGroup = memo(
  ({
    columns,
    title,
    isVisible,
    toggleAllButtonText,
    className,
    toggleAllColumns,
    toggleColumnVisibility,
  }: SortableGroupProps) => {
    return (
      <CommandGroup className={cn('px-2', className)}>
        <div className="flex items-center justify-between px-2 py-1.5">
          <span className="text-xs text-primary font-semibold">{title}</span>
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="h-auto p-0 text-xs font-normal text-secondary hover:text-secondary hover:bg-transparent"
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              toggleAllColumns()
            }}
            onPointerDown={(e) => e.stopPropagation()}
          >
            {toggleAllButtonText}
          </Button>
        </div>
        <Separator className="my-1" />
        <SortableContext
          items={columns.map((col) => col.id)}
          strategy={verticalListSortingStrategy}
        >
          {columns.map((column) => (
            <SortableItem
              key={column.id}
              column={column}
              onToggle={toggleColumnVisibility}
              isVisible={isVisible}
            />
          ))}
        </SortableContext>
      </CommandGroup>
    )
  }
)

SortableGroup.displayName = 'SortableGroup'

export { SortableGroup }
export type { SortableGroupProps }
